import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "lini-view-container" }
const _hoisted_2 = {
  key: 0,
  class: "lean-header-strip"
}
const _hoisted_3 = { class: "header-left" }
const _hoisted_4 = { class: "doc-identity" }
const _hoisted_5 = { class: "doc-text" }
const _hoisted_6 = ["title"]
const _hoisted_7 = { class: "doc-meta-chips" }
const _hoisted_8 = { class: "chip no" }
const _hoisted_9 = { class: "chip date" }
const _hoisted_10 = { class: "chip type" }
const _hoisted_11 = {
  key: 0,
  class: "chip valoare"
}
const _hoisted_12 = {
  key: 1,
  class: "chip tva"
}
const _hoisted_13 = {
  key: 2,
  class: "chip tva-val"
}
const _hoisted_14 = {
  key: 3,
  class: "chip total"
}
const _hoisted_15 = {
  key: 4,
  class: "chip sold"
}
const _hoisted_16 = {
  key: 5,
  class: "chip curs"
}
const _hoisted_17 = {
  key: 6,
  class: "chip adaos"
}
const _hoisted_18 = { class: "header-right" }
const _hoisted_19 = {
  key: 1,
  class: "grid-section"
}
const _hoisted_20 = { class: "circle-container" }
const _hoisted_21 = {
  key: 0,
  class: "circle circle-true"
}
const _hoisted_22 = {
  key: 1,
  class: "circle circle-false"
}
const _hoisted_23 = {
  key: 2,
  class: "no-lines-empty-state"
}
const _hoisted_24 = {
  key: 3,
  class: "null-document-state"
}
const _hoisted_25 = { class: "form-footer-linie footer-fixed-linie footer-modern-linie" }
const _hoisted_26 = { class: "footer-right-linie" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxExport = _resolveComponent("DxExport")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxTexts = _resolveComponent("DxTexts")!
  const _component_DxGrouping = _resolveComponent("DxGrouping")!
  const _component_DxToolbarItem = _resolveComponent("DxToolbarItem")!
  const _component_DxPopup = _resolveComponent("DxPopup")!
  const _component_DxLabel = _resolveComponent("DxLabel")!
  const _component_DxItem = _resolveComponent("DxItem")!
  const _component_DxFormEdit = _resolveComponent("DxFormEdit")!
  const _component_DxEditing = _resolveComponent("DxEditing")!
  const _component_DxDropDownOptions = _resolveComponent("DxDropDownOptions")!
  const _component_DxLookup = _resolveComponent("DxLookup")!
  const _component_DxNumberBox = _resolveComponent("DxNumberBox")!
  const _component_DxGroupPanel = _resolveComponent("DxGroupPanel")!
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_DxSorting = _resolveComponent("DxSorting")!
  const _component_DxColumnChooser = _resolveComponent("DxColumnChooser")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxToolbar = _resolveComponent("DxToolbar")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_DxSimpleItem = _resolveComponent("DxSimpleItem")!
  const _component_DxForm = _resolveComponent("DxForm")!
  const _component_DxPopupAdd = _resolveComponent("DxPopupAdd")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.document)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[2] || (_cache[2] = _createElementVNode("i", { class: "dx-icon-doc" }, null, -1)),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", {
                  class: "partner-name truncate",
                  title: _ctx.document.Partener
                }, _toDisplayString(_ctx.document.Partener), 9, _hoisted_6),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, "#" + _toDisplayString(_ctx.document.Numar), 1),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.formatDate(_ctx.document.Data)), 1),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.document.Tip), 1),
                  (_ctx.document.Valoare)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, "V: " + _toDisplayString(_ctx.document.Valoare.toLocaleString('ro-RO', { minimumFractionDigits: 2 })), 1))
                    : _createCommentVNode("", true),
                  (_ctx.document.Tva)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, "TVA: " + _toDisplayString(_ctx.document.Tva) + "%", 1))
                    : _createCommentVNode("", true),
                  (_ctx.document.ValoareTva)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, "VTVA: " + _toDisplayString(_ctx.document.ValoareTva.toLocaleString('ro-RO', { minimumFractionDigits: 2 })), 1))
                    : _createCommentVNode("", true),
                  (_ctx.document.Total)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, "TOTAL: " + _toDisplayString(_ctx.document.Total.toLocaleString('ro-RO', { minimumFractionDigits: 2 })) + " " + _toDisplayString(_ctx.document.Valuta), 1))
                    : _createCommentVNode("", true),
                  (_ctx.document.Sold)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, "SOLD: " + _toDisplayString(_ctx.document.Sold.toLocaleString('ro-RO',
                                { minimumFractionDigits: 2 })), 1))
                    : _createCommentVNode("", true),
                  (_ctx.document.Curs)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, "CURS: " + _toDisplayString(_ctx.document.Curs.toLocaleString('ro-RO',
                                { minimumFractionDigits: 4 })), 1))
                    : _createCommentVNode("", true),
                  (_ctx.document.Adaos)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, "ADAOS: " + _toDisplayString(_ctx.document.Adaos.toLocaleString('ro-RO', { minimumFractionDigits: 2 })), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_DxButton, {
              icon: "info",
              hint: "Detalii Document",
              "styling-mode": "text",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle-details'))),
              class: "detail-btn"
            }),
            _createVNode(_component_DxButton, {
              icon: "share",
              hint: "Partajează",
              "styling-mode": "text",
              onClick: _ctx.shareClicked
            }, null, 8, ["onClick"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.areLinii)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createVNode(_component_DxDataGrid, {
            ref: "dataGrid",
            "data-source": _ctx.dsLinii,
            allowColumnReordering: true,
            allowColumnResizing: true,
            columnAutoWidth: false,
            columnMinWidth: 50,
            "show-borders": true,
            syncLookupFilterValues: false,
            "filter-sync-enabled": true,
            onSaved: _ctx.onGridSaved,
            onSaving: _ctx.onSavingLinie,
            onEditingStart: _ctx.onEditingStartLinie
          }, {
            produsEditTemplate: _withCtx(({ data }) => [
              _createVNode(_component_DxLookup, {
                "data-source": _ctx.dsProdus,
                "value-expr": "Id",
                "display-expr": _ctx.produsDisplayExpr,
                "show-clear-button": true,
                "search-enabled": true,
                value: data.value,
                onValueChanged: (e) => data.setValue(e.value)
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxDropDownOptions, { "show-title": false })
                ]),
                _: 1
              }, 8, ["data-source", "display-expr", "value", "onValueChanged"])
            ]),
            cantitateEditTemplate: _withCtx(({ data }) => [
              _createVNode(_component_DxNumberBox, {
                value: data.value,
                min: 1,
                step: 1,
                "show-spin-buttons": true,
                "show-clear-button": true,
                label: "Cantitate",
                onValueChanged: (e) => data.setValue(e.value)
              }, null, 8, ["value", "onValueChanged"])
            ]),
            unitateEditTemplate: _withCtx(({ data }) => [
              _createVNode(_component_DxLookup, {
                "data-source": _ctx.dsUnitate,
                "value-expr": "Id",
                "display-expr": "Nume",
                "show-clear-button": true,
                "search-enabled": true,
                value: data.value,
                onValueChanged: (e) => data.setValue(e.value)
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxDropDownOptions, { "show-title": false })
                ]),
                _: 1
              }, 8, ["data-source", "value", "onValueChanged"])
            ]),
            tvaEditTemplate: _withCtx(({ data }) => [
              _createVNode(_component_DxNumberBox, {
                value: data.value,
                min: 0,
                step: 1,
                "show-spin-buttons": true,
                "show-clear-button": true,
                format: "## %",
                onValueChanged: (e) => data.setValue(e.value)
              }, null, 8, ["value", "onValueChanged"])
            ]),
            pretUnitarEditTemplate: _withCtx(({ data }) => [
              _createVNode(_component_DxNumberBox, {
                value: data.value,
                min: 0,
                step: 1,
                "show-spin-buttons": true,
                "show-clear-button": true,
                format: { type: 'fixedPoint', precision: 4 },
                onValueChanged: (e) => data.setValue(e.value)
              }, null, 8, ["value", "onValueChanged"])
            ]),
            categorieContabilaEditTemplate: _withCtx(({ data }) => [
              _createVNode(_component_DxLookup, {
                "data-source": _ctx.dsCategorieContabila,
                "value-expr": "Id",
                "display-expr": "Nume",
                "show-clear-button": true,
                "search-enabled": true,
                value: data.value,
                onValueChanged: (e) => data.setValue(e.value)
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxDropDownOptions, { "show-title": false })
                ]),
                _: 1
              }, 8, ["data-source", "value", "onValueChanged"])
            ]),
            pretTotalEditTemplate: _withCtx(({ data }) => [
              _createVNode(_component_DxNumberBox, {
                value: data.value,
                "read-only": true
              }, null, 8, ["value"])
            ]),
            totalEditTemplate: _withCtx(({ data }) => [
              _createVNode(_component_DxNumberBox, {
                value: data.value,
                "read-only": true
              }, null, 8, ["value"])
            ]),
            circleTemplate: _withCtx(({ data }) => [
              _createElementVNode("div", _hoisted_20, [
                (data.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, "✔"))
                  : (_openBlock(), _createElementBlock("div", _hoisted_22))
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_DxExport, {
                enabled: true,
                formats: ["pdf", "xlsx"],
                "allow-export-selected-data": true
              }),
              _createVNode(_component_DxFilterRow, { visible: true }),
              _createVNode(_component_DxGrouping, { "context-menu-enabled": true }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxTexts, {
                    "group-continued-message": "Continuat de pe pagina anterioara",
                    "group-continues-message": "Continuat pe pagina urmatoare"
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_DxEditing, {
                allowUpdating: true,
                allowDeleting: false,
                mode: "popup"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxPopup, {
                    closeOnOutsideClick: false,
                    showCloseButton: false,
                    width: 800,
                    height: 450
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxToolbarItem, { template: _ctx.customTitleTemplate }, null, 8, ["template"]),
                      _createVNode(_component_DxToolbarItem, {
                        toolbar: "bottom",
                        widget: "dxButton",
                        location: "after",
                        options: _ctx.successButtonOptions
                      }, null, 8, ["options"]),
                      _createVNode(_component_DxToolbarItem, {
                        toolbar: "bottom",
                        widget: "dxButton",
                        location: "after",
                        options: _ctx.dangerButtonOptions
                      }, null, 8, ["options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DxFormEdit, { "col-count": 2 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxItem, {
                        "data-field": "ProdusId",
                        "is-required": true
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DxLabel, { text: "Produs" })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_DxItem, {
                        "data-field": "Cantitate",
                        "is-required": true
                      }),
                      _createVNode(_component_DxItem, {
                        "data-field": "UnitateId",
                        "is-required": true
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DxLabel, { text: "Unitate" })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_DxItem, {
                        "data-field": "Tva",
                        "is-required": true
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DxLabel, { text: "Procent TVA" })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_DxItem, {
                        "data-field": "PretUnitar",
                        "is-required": true
                      }),
                      _createVNode(_component_DxItem, {
                        "data-field": "CategorieContabilaId",
                        "is-required": true
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DxLabel, { text: "Categorie Contabilă" })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_DxItem, {
                        "data-field": "PretTotal",
                        "read-only": true
                      }),
                      _createVNode(_component_DxItem, {
                        "data-field": "Total",
                        "read-only": true
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DxTexts, {
                    "confirm-delete-title": "Confirmare Ștergere",
                    "confirm-delete-message": _ctx.deleteConfirmationMessage
                  }, null, 8, ["confirm-delete-message"])
                ]),
                _: 1
              }),
              _createVNode(_component_DxGroupPanel, {
                visible: true,
                emptyPanelText: "Trage aici o coloana pentru a grupa datele"
              }),
              _createVNode(_component_DxLoadPanel, { enabled: true }),
              _createVNode(_component_DxSorting, { mode: "multiple" }),
              _createVNode(_component_DxColumnChooser, {
                enabled: true,
                title: "Selector coloane",
                allowSearch: true,
                sortOrder: "asc"
              }),
              _createVNode(_component_DxSearchPanel, {
                visible: true,
                width: 240,
                placeholder: "Cauta ..."
              }),
              _createVNode(_component_DxPaging, {
                "page-size": 10,
                "page-index": 1
              }),
              _createVNode(_component_DxToolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_DxItem, {
                    widget: "dxButton",
                    location: "after",
                    options: _ctx.addButtonOptions
                  }, null, 8, ["options"]),
                  _createVNode(_component_DxItem, { name: "searchPanel" }),
                  _createVNode(_component_DxItem, { name: "exportButton" }),
                  _createVNode(_component_DxItem, { name: "columnChooserButton" })
                ]),
                _: 1
              }),
              _createVNode(_component_DxColumn, { caption: "Produs" }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxColumn, {
                    "data-field": "ProdusId",
                    visible: false,
                    "set-cell-value": _ctx.onProdusIdCellValueChanged,
                    "edit-cell-template": "produsEditTemplate"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxLookup, {
                        "data-source": _ctx.dsProdus,
                        "value-expr": "Id",
                        "display-expr": _ctx.produsDisplayExpr
                      }, null, 8, ["data-source", "display-expr"])
                    ]),
                    _: 1
                  }, 8, ["set-cell-value"]),
                  _createVNode(_component_DxColumn, {
                    "data-field": "Produs.Cod",
                    caption: "Cod Produs",
                    allowFiltering: true
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "Produs.Nume",
                    caption: "Nume Produs",
                    allowFiltering: true
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_DxColumn, { caption: "Unitate" }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxColumn, {
                    "data-field": "UnitateId",
                    visible: false,
                    "edit-cell-template": "unitateEditTemplate"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxLookup, {
                        "data-source": _ctx.dsUnitate,
                        "value-expr": "Id",
                        "display-expr": "Nume"
                      }, null, 8, ["data-source"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "Unitate.Simbol",
                    caption: "Simbol Unitate",
                    allowFiltering: false
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "Unitate.Cod",
                    caption: "Cod Unitate",
                    allowFiltering: false
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "Unitate.Nume",
                    caption: "Nume Unitate",
                    allowFiltering: true
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "Nume",
                caption: "Nume",
                visible: false,
                allowFiltering: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "Custom",
                caption: "Custom",
                visible: false,
                allowFiltering: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "Cantitate",
                caption: "Cantitate",
                "data-type": "number",
                allowFiltering: false,
                "edit-cell-template": "cantitateEditTemplate"
              }),
              _createVNode(_component_DxColumn, { caption: "Rezumat Financiar" }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxColumn, {
                    "data-field": "TVAUnitar",
                    caption: "TVA Unitar",
                    "data-type": "number",
                    format: "#0.00",
                    visible: false,
                    allowFiltering: false
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "ValoareTva",
                    caption: "Valoare TVA",
                    "data-type": "number",
                    format: "#0.00",
                    allowFiltering: false
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "Tva",
                    caption: "TVA",
                    "data-type": "number",
                    format: "#0.00",
                    visible: false,
                    allowFiltering: false,
                    "edit-cell-template": "tvaEditTemplate"
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "CategTva",
                    caption: "Categorie TVA",
                    visible: false,
                    allowFiltering: false
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "CategTvaMotivScutire",
                    caption: "Categorie TVA Motiv Scutire",
                    visible: false,
                    allowFiltering: false
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "PretUnitar",
                    caption: "Pret Unitar",
                    "data-type": "number",
                    format: "#0.00",
                    allowFiltering: false,
                    "edit-cell-template": "pretUnitarEditTemplate"
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "PretTotal",
                    caption: "Pret Total",
                    "data-type": "number",
                    format: "#0.00",
                    visible: false,
                    allowFiltering: false,
                    "edit-cell-template": "pretTotalEditTemplate"
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "CategorieContabilaId",
                    visible: false,
                    "edit-cell-template": "categorieContabilaEditTemplate"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxLookup, {
                        "data-source": _ctx.dsCategorieContabila,
                        "value-expr": "Id",
                        "display-expr": "Nume"
                      }, null, 8, ["data-source"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "Valoare",
                    caption: "Valoare",
                    "data-type": "number",
                    format: "#0.00",
                    visible: false,
                    allowFiltering: false
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "Total",
                    caption: "Total",
                    "data-type": "number",
                    format: "#0.00",
                    visible: false,
                    allowFiltering: false,
                    "edit-cell-template": "totalEditTemplate"
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "Pret",
                    caption: "Pret",
                    "data-type": "number",
                    format: "#0.00",
                    visible: false,
                    allowFiltering: false
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "ValoarePret",
                    caption: "Valoare Pret",
                    "data-type": "number",
                    format: "#0.00",
                    visible: false,
                    allowFiltering: false
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "AdaosUnitar",
                    caption: "Adaos Unitar",
                    "data-type": "number",
                    format: "#0.00",
                    visible: false,
                    allowFiltering: false
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "ValoareAdaos",
                    caption: "Valoare Adaos",
                    "data-type": "number",
                    format: "#0.00",
                    visible: false,
                    allowFiltering: false
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "Adaos",
                    caption: "Adaos",
                    "data-type": "number",
                    format: "#0.00",
                    visible: false,
                    allowFiltering: false
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "Brut",
                    caption: "Brut",
                    "data-type": "number",
                    format: "#0.00",
                    visible: false,
                    allowFiltering: false
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "PretUnitarValuta",
                    caption: "Pret Unitar Valuta",
                    "data-type": "number",
                    format: "#0.00",
                    visible: false,
                    allowFiltering: false
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "PretCuAdaos",
                    caption: "Pret cu Adaos",
                    "data-type": "number",
                    format: "#0.00",
                    visible: false,
                    allowFiltering: false
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "ValoareCuAdaos",
                    caption: "Valoare cu Adaos",
                    "data-type": "number",
                    format: "#0.00",
                    allowFiltering: false
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "SumaDistribuita",
                    caption: "Suma Distribuita",
                    "data-type": "number",
                    format: "#0.00",
                    visible: false,
                    allowFiltering: false
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "PretVanzareAdaos",
                    caption: "Pret Vanzare Adaos",
                    "data-type": "number",
                    format: "#0.00",
                    visible: false,
                    allowFiltering: false
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "PretVanzareReferinta",
                    caption: "Pret Vanzare Referinta",
                    "data-type": "number",
                    format: "#0.00",
                    visible: false,
                    allowFiltering: false
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "PretVanzareAdaosProc",
                    caption: "Pret Vanzare Adaos Proc",
                    "data-type": "number",
                    format: "#0.00",
                    visible: false,
                    allowFiltering: false
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_DxColumn, {
                caption: "Document Totals (Info)",
                visible: false
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxColumn, {
                    "calculate-cell-value": () => _ctx.document.Valoare,
                    caption: "Valoare (Doc)",
                    allowFiltering: false,
                    format: "#,##0.00"
                  }, null, 8, ["calculate-cell-value"]),
                  _createVNode(_component_DxColumn, {
                    "calculate-cell-value": () => _ctx.document.TVA,
                    caption: "TVA (Doc)",
                    allowFiltering: false,
                    format: "#0"
                  }, null, 8, ["calculate-cell-value"]),
                  _createVNode(_component_DxColumn, {
                    "calculate-cell-value": () => _ctx.document.ValoareTVA,
                    caption: "Valoare TVA (Doc)",
                    allowFiltering: false,
                    format: "#,##0.00"
                  }, null, 8, ["calculate-cell-value"]),
                  _createVNode(_component_DxColumn, {
                    "calculate-cell-value": () => _ctx.document.Total,
                    caption: "Total (Doc)",
                    allowFiltering: false,
                    format: "#,##0.00"
                  }, null, 8, ["calculate-cell-value"]),
                  _createVNode(_component_DxColumn, {
                    "calculate-cell-value": () => _ctx.document.Sold,
                    caption: "Sold (Doc)",
                    allowFiltering: false,
                    format: "#,##0.00"
                  }, null, 8, ["calculate-cell-value"]),
                  _createVNode(_component_DxColumn, {
                    "calculate-cell-value": () => _ctx.document.Valuta,
                    caption: "Valuta (Doc)",
                    allowFiltering: false
                  }, null, 8, ["calculate-cell-value"]),
                  _createVNode(_component_DxColumn, {
                    "calculate-cell-value": () => _ctx.document.Curs,
                    caption: "Curs (Doc)",
                    allowFiltering: false,
                    format: "#,##0.0000"
                  }, null, 8, ["calculate-cell-value"]),
                  _createVNode(_component_DxColumn, {
                    "calculate-cell-value": () => _ctx.document.Adaos,
                    caption: "Adaos (Doc)",
                    allowFiltering: false,
                    format: "#,##0.00"
                  }, null, 8, ["calculate-cell-value"])
                ]),
                _: 1
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "Intrari",
                caption: "Intrari",
                "data-type": "number",
                visible: false,
                allowFiltering: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "Iesiri",
                caption: "Iesiri",
                "data-type": "number",
                visible: false,
                allowFiltering: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "DataExp",
                caption: "Data Expirarii",
                allowFiltering: false,
                "data-type": "date",
                format: "yyyy-MM-dd",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "LotData",
                caption: "Data Lot",
                allowFiltering: false,
                "data-type": "date",
                format: "yyyy-MM-dd",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "CantitateFa",
                caption: "CantitateFa",
                "data-type": "number",
                format: "#0.00",
                visible: false,
                allowFiltering: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "CantitatePt1Fa",
                caption: "CantitatePt1Fa",
                "data-type": "number",
                format: "#0.00",
                visible: false,
                allowFiltering: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "CodLotIntern",
                caption: "Cod Lot Intern",
                visible: false,
                allowFiltering: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "CodLotFurnizor",
                caption: "Cod Lot Furnizor",
                visible: false,
                allowFiltering: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "Sursa Finantare",
                caption: "SursaFinantare",
                visible: false,
                allowFiltering: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "LocDepozitare",
                caption: "Loc Depozitare",
                visible: false,
                allowFiltering: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "GarantieLuni",
                caption: "Luni de Garantie",
                "data-type": "number",
                visible: false,
                allowFiltering: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "LotFixat",
                caption: "Lot Fixat?",
                visible: false,
                allowFiltering: false,
                cellTemplate: "circleTemplate"
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "CodNc8",
                caption: "Cod NC8",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "MasaNet",
                caption: "Masa Net",
                "data-type": "number",
                format: "#0.00",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "MasaBrut",
                caption: "Masa Brut",
                "data-type": "number",
                format: "#0.00",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                caption: "Categorie",
                visible: false
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxColumn, {
                    "data-field": "Categorie.Cod",
                    caption: "Cod Categorie",
                    allowFiltering: false
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "Categorie.Nume",
                    caption: "Nume Categorie",
                    allowFiltering: false
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_DxColumn, {
                type: "buttons",
                "visible-index": 9999,
                width: "90",
                buttons: ['edit']
              })
            ]),
            _: 1
          }, 8, ["data-source", "onSaved", "onSaving", "onEditingStart"])
        ]))
      : (_ctx.document)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _cache[3] || (_cache[3] = _createElementVNode("i", { class: "dx-icon-info" }, null, -1)),
            _cache[4] || (_cache[4] = _createElementVNode("p", null, "Acest document nu are linii adăugate.", -1)),
            _createVNode(_component_DxButton, {
              icon: "add",
              text: "Adaugă prima linie",
              type: "success",
              "styling-mode": "contained",
              onClick: _ctx.onAddClick
            }, null, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true),
    (_ctx.document === null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [...(_cache[5] || (_cache[5] = [
          _createElementVNode("i", { class: "dx-icon-warning" }, null, -1),
          _createElementVNode("p", null, "Vă rugăm să selectați un document pentru a vedea detaliile.", -1)
        ]))]))
      : _createCommentVNode("", true),
    _createVNode(_component_DxPopupAdd, {
      visible: _ctx.isModalAddVisible,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isModalAddVisible) = $event)),
      showTitle: true,
      width: 700,
      height: 450
    }, {
      title: _withCtx(() => [...(_cache[6] || (_cache[6] = [
        _createElementVNode("div", { class: "popup-header-linie" }, [
          _createElementVNode("div", { class: "popup-header-main-linie" }, [
            _createElementVNode("span", { class: "popup-header-icon-linie dx-icon-add" }),
            _createElementVNode("div", { class: "popup-header-texts-linie" }, [
              _createElementVNode("div", { class: "popup-header-title-linie" }, "Adăugare linie document"),
              _createElementVNode("div", { class: "popup-header-subtitle-linie" }, " Completează detaliile liniei documentului în pașii de mai jos ")
            ])
          ]),
          _createElementVNode("div", { class: "popup-header-meta-linie" }, [
            _createElementVNode("span", { class: "status-chip-linie status-chip-linie--draft" }, " Nou ")
          ])
        ], -1)
      ]))]),
      default: _withCtx(() => [
        _createVNode(_component_DxForm, {
          "form-data": _ctx.linieNoua,
          "col-count": 2
        }, {
          produs: _withCtx(() => [
            _createVNode(_component_DxLookup, {
              "data-source": _ctx.dsProdus,
              "value-expr": "Id",
              "display-expr": _ctx.produsDisplayExpr,
              showClearButton: true,
              searchEnabled: true,
              onValueChanged: _ctx.onValueChangedProdus,
              value: _ctx.linieNoua.ProdusId
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxDropDownOptions, { "show-title": false })
              ]),
              _: 1
            }, 8, ["data-source", "display-expr", "onValueChanged", "value"])
          ]),
          cantitate: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_DxNumberBox, {
                value: _ctx.linieNoua.Cantitate,
                min: 1,
                step: 1,
                "show-spin-buttons": true,
                "show-clear-button": true,
                label: "Cantitate",
                onValueChanged: _ctx.onCantitateChanged
              }, null, 8, ["value", "onValueChanged"])
            ])
          ]),
          unitate: _withCtx(() => [
            _createVNode(_component_DxLookup, {
              "data-source": _ctx.dsUnitate,
              "value-expr": "Id",
              "display-expr": "Nume",
              showClearButton: true,
              searchEnabled: true,
              value: _ctx.linieNoua.UnitateId,
              onValueChanged: _ctx.onUnitateChanged
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxDropDownOptions, { "show-title": false })
              ]),
              _: 1
            }, 8, ["data-source", "value", "onValueChanged"])
          ]),
          procentTVA: _withCtx(() => [
            _createVNode(_component_DxNumberBox, {
              value: _ctx.linieNoua.Tva,
              min: 0,
              step: 1,
              "show-spin-buttons": true,
              "show-clear-button": true,
              format: "## '%'",
              onValueChanged: _ctx.onTVAChanged
            }, null, 8, ["value", "onValueChanged"])
          ]),
          "pret-unitar": _withCtx(() => [
            _createVNode(_component_DxNumberBox, {
              min: 0,
              value: _ctx.linieNoua.PretUnitar,
              step: 1,
              "show-spin-buttons": true,
              "show-clear-button": true,
              format: { type: 'fixedPoint', precision: 4 },
              onValueChanged: _ctx.onPretUnitarChanged
            }, null, 8, ["value", "onValueChanged"])
          ]),
          "categorie-contabila": _withCtx(() => [
            _createVNode(_component_DxLookup, {
              "data-source": _ctx.dsCategorieContabila,
              "value-expr": "Id",
              "display-expr": "Nume",
              showClearButton: true,
              searchEnabled: true,
              value: _ctx.linieNoua.CategorieContabilaId,
              onValueChanged: _ctx.onCategorieContabilaChanged
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxDropDownOptions, { "show-title": false })
              ]),
              _: 1
            }, 8, ["data-source", "value", "onValueChanged"])
          ]),
          "pret-total": _withCtx(() => [
            _createVNode(_component_DxNumberBox, {
              value: _ctx.linieNoua.PretTotal,
              readOnly: true
            }, null, 8, ["value"])
          ]),
          total: _withCtx(() => [
            _createVNode(_component_DxNumberBox, {
              value: _ctx.linieNoua.Total,
              readOnly: true
            }, null, 8, ["value"])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_DxSimpleItem, {
              "data-field": "ProdusId",
              template: "produs",
              isRequired: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxLabel, { text: "Produs" })
              ]),
              _: 1
            }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "Cantitate",
              template: "cantitate",
              isRequired: true
            }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "UnitateId",
              template: "unitate",
              isRequired: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxLabel, { text: "Unitate" })
              ]),
              _: 1
            }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "Tva",
              template: "procentTVA",
              isRequired: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxLabel, { text: "Procent TVA" })
              ]),
              _: 1
            }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "PretUnitar",
              template: "pret-unitar",
              isRequired: true
            }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "CategorieContabilaId",
              template: "categorie-contabila",
              isRequired: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxLabel, { text: "Categorie Contabilă" })
              ]),
              _: 1
            }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "PretTotal",
              template: "pret-total",
              readOnly: true
            }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "Total",
              template: "total",
              readOnly: true
            })
          ]),
          _: 1
        }, 8, ["form-data"]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_component_DxButton, {
              text: "Salvează",
              type: "success",
              width: "120",
              height: "32",
              "styling-mode": "outlined",
              onClick: _ctx.onSaveAdd
            }, null, 8, ["onClick"]),
            _createVNode(_component_DxButton, {
              text: "Închide",
              type: "danger",
              width: "120",
              height: "32",
              "styling-mode": "outlined",
              onClick: _ctx.onCloseAdd
            }, null, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}